import { ArrowRightIcon } from '@heroicons/react/20/solid'

import { Button } from '@ui/components/core'

import { ReclaimSchedulingLinkEmbed } from './ReclaimSchedulingLinkEmbed'

const JIMS_RECLAIM_LINK_ID = '38204637-b099-4bfd-bd5e-6fdd4234e0a7'

export const NoAvailability = ({ onTryDemo }: { onTryDemo: () => void }) => {
  return (
    <div className="flex flex-col items-center justify-center gap-12 space-x-10 border-2 border-gray-200 p-4 py-24">
      <div className="flex max-w-[37.5rem] flex-col items-center justify-center space-y-4">
        <h1 className="text-4xl font-semibold text-secondary-800">Thanks for signing up!</h1>
        <p className="text-base text-gray-600">
          Feel free to explore the Sandbox or book a meeting to get started right away.
        </p>
        <Button
          onClick={onTryDemo}
          variant="primary"
          className="bg-primary-500"
          icon={<ArrowRightIcon className="h-4 w-4" />}
          iconPosition="right">
          Try the Sandbox
        </Button>
      </div>
      <div className="w-[840px]">
        <ReclaimSchedulingLinkEmbed linkId={JIMS_RECLAIM_LINK_ID} />
      </div>
    </div>
  )
}
